import '../App.css';
import '../scss/App.scss';
import { Box, Container, Grid, Link } from '@mui/material';
import React, { useState } from 'react';
import Content from '../layout/content-box/Content';

function Contact() {

  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validate = () => {
    let tempErrors = {};
    if (!form.firstName.trim()) tempErrors.firstName = "First name is required.";
    if (!form.email.trim()) tempErrors.email = "Email is required.";
    else if (!/\S+@\S+\.\S+/.test(form.email)) tempErrors.email = "Email is invalid.";
    if (!form.message.trim()) tempErrors.message = "Message is required.";
    return tempErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length === 0) {
      alert("Form submitted successfully!");
      console.log("Submitted Data:", form);
      // You can send the data to a server here
    } else {
      setErrors(validationErrors);
    }
  };
  return (
    <>
      <Box className="aboutBanner contactBanner" >
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="left" alignItems="center">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="bannerText text-center">
                <h1>{Content[0].contactHeading}</h1>
                <span>We’d love to hear from you! Whether you have a question, want to <br /> suggest a temple to be featured, or are interested in collaborating, <br /> your input is always welcome.</span>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <section className="founderBox">
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="left">

            <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >

              <Box className="lightGrayBox">
                <Box className="aboutHeading mb-4">
                  <h2>{Content[0].contactGetInTouch}</h2>
                </Box>
                <Box className="contactDetail">
                  <Box className="contactIcon">
                    <img src="../assets/location-icon.svg" alt="" className="img-fluid" />
                  </Box>

                  <Box className="contactText">
                    <span>Head Office</span>
                    <p className='mb-1'><strong>Delhi :</strong> 2-A/3, S/F Front Side,
                        Asaf Ali Road, Turkman Gate, Delhi,
                      Indraprastha Estate, New Delhi 110002</p>
                      <span className='d-block mb-3'>GST: 07ABACA7352H1ZR</span>
                      <span> Branch Office</span>
                    <p className='mb-1'><strong>Jammu :</strong> Ground Floor, Hall No. 2, Kaytech House, Ajit Nagar,
Airport Road, Rakh Gadi Garh, Jammu and Kashmir, 181101</p>
                      <span className='d-block mb-3'>GST: 01ABACA7352H1Z3</span>
                  </Box>
                </Box>

                <Box className=" contactDetail">
                  <Box className="contactIcon">
                    <img src="../assets/email-icon.svg" alt="" className="img-fluid" />
                  </Box>
                  <Box className="contactText">
                    <span>Email Us</span>
                    <p className="mb-0"><Link href="mailto:info@mandir.wiki">info@mandir.wiki</Link></p>
                    <p className="mt-0"><Link href="mailto:info@arixpower.com">info@arixpower.com</Link></p>
                  </Box>
                </Box>

                <Box className=" contactDetail">
                  <Box className="contactIcon">
                    <img src="../assets/phone-icon.svg" alt="" className="img-fluid" />
                  </Box>
                  <Box className="contactText">
                    <span>Call Us</span>
                    <p><Link href="tel:+919625974411">+91 9625974411</Link></p>
                  </Box>
                </Box>
              </Box>

              <Box className="mt-4">
                <iframe src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3501.5568552364307!2d77.23024327375309!3d28.64304073360659!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s203%2C%202-A%2F3%2C%20S%2FF%20Front%20Side%2C%20Asaf%20Ali%20Road%2C%20Turkman%20Gate%2C%20New%20Delhi-110002!5e0!3m2!1sen!2sin!4v1746639280435!5m2!1sen!2sin" width="100%" height="350" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
              </Box>


            </Grid>
            {/* <Grid size={{ xl: 1, lg: 1, md: 1, sm: 12, xs: 12 }} >
              
            </Grid> */}
            <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
              <Box className="contactForm">
                <Box className="aboutHeading mb-4">
                  <h2>{Content[0].contactFromHeading}</h2>
                </Box>
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label>First Name*</label>
                    <input
                      type="text"
                      className="form-control"
                      name="firstName"
                      placeholder="Enter your name"
                      value={form.firstName}
                      onChange={handleChange}
                    />
                    {errors.firstName && <small className="text-danger">{errors.firstName}</small>}
                  </div>

                  <div className="form-group">
                    <label>Last Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="lastName"
                      placeholder="Enter your last name"
                      value={form.lastName}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Phone no</label>
                    <input
                      type="text"
                      className="form-control"
                      name="lastName"
                      placeholder="Enter your phone no"
                      value={form.lastName}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Email Address*</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      placeholder="Enter your email"
                      value={form.email}
                      onChange={handleChange}
                    />
                    {errors.email && <small className="text-danger">{errors.email}</small>}
                  </div>

                  <div className="form-group">
                    <label>Message*</label>
                    <textarea
                      className="form-control"
                      name="message"
                      placeholder="Enter your message"
                      value={form.message}
                      onChange={handleChange}
                    />
                    {errors.message && <small className="text-danger">{errors.message}</small>}
                  </div>

                  <div className="mt-4">
                    <button className="btn btn-success btn-sm" type="submit">
                      Send Message
                    </button>
                  </div>
                </form>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </section>
    </>
  );
}
export default Contact;